import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useModal } from 'components/modals/ModalContext';
import '../../style/scss/modals.scss';

// Type of the compact contract data on the job
export interface ServiceContractSummaryType {
    id: number;
    reference: string | null;
    status: 'active' | 'expired' | 'cancelled';
    interval_type: string | null;
}

const ServiceContractSummaryCard: React.FC<{
    contract: ServiceContractSummaryType;
}> = ({
    contract,
}) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { closeModal } = useModal();

    // Open the contract page the job was created from
    const openContract = () => {
        history.push(`/contracts/${contract.id}`);
        closeModal();
    };

    return (
        <div className='summary-object-card'>
            <h6>{t('contract.general.service_contract_label')}</h6>
            <div className='summary-object-card-item' onClick={openContract}>
                <div className='item-text'>
                    <div className='item-title'>
                        {contract.reference || t('contract.general.object_name.singular')}
                    </div>
                    {contract.interval_type && (
                        <div className='item-subtitle'>
                            {t(`contract.interval.${contract.interval_type}`)}
                        </div>
                    )}
                </div>
                <div className='item-meta'>
                    {t(`contract.status_name.${contract.status}`).toLowerCase()}
                </div>
            </div>
        </div>
    );
};

export default ServiceContractSummaryCard;
